<template>
  <GiftRowBase
    :img="'https://mylastwill.s3.amazonaws.com/static/img/button-gift-item.png'"
    :description="description"
    :shared="gift.beneficiary_group_share"
    :beneficiary="gift.beneficiary_group || gift.beneficiary.full_name"
    @editGift="$emit('editOtherGift')"
    @deleteGift="$emit('deleteOtherGift')"
  >
  </GiftRowBase>
</template>

<script>
import GiftRowBase from './RowBase'
import { TextFormat } from '@/common/mixins/TextFormat'

export default {
  name: 'GiftRowOther',
  props: ['gift'],
  mixins: [TextFormat],
  components: {
    GiftRowBase
  },
  computed: {
    description() {
      return this.truncate(this.gift.item, 20)
    }
  }
}
</script>
